"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _variables = require("../../../global-files/variables");

var _BoxOnboarding = require("../BoxOnboarding");

var _BoxButtons = require("../../molecules/BoxButtons");

var _jsxRuntime = require("react/jsx-runtime");

var Box = function Box(_ref) {
  var onChange = _ref.onChange,
      dataInputs = _ref.dataInputs,
      inputGroup = _ref.inputGroup;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isDeleteDisabled = _useState2[0],
      setIsDeleteDisabled = _useState2[1];

  var _useState3 = (0, _react.useState)([{
    showAdd: true,
    value: {}
  }]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      boxOnboardingList = _useState4[0],
      setBoxOnboardingList = _useState4[1];

  (0, _react.useEffect)(function () {
    var temp = {};
    var maxBoxId = 0;
    inputGroup.inputs.forEach(function (attrId) {
      if (!dataInputs[attrId].box) return;
      Object.entries(dataInputs[attrId].box).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            boxId = _ref3[0],
            value = _ref3[1];

        if (boxId > maxBoxId) maxBoxId = boxId;
        if (!temp[boxId]) temp[boxId] = {};
        temp[boxId][attrId] = value;
      });
    });
    var tempList = Object.values(temp);

    if (tempList.length > 0) {
      setBoxOnboardingList(tempList.map(function (value, index) {
        return index === tempList.length - 1 ? {
          showAdd: true,
          value: value
        } : {
          value: value
        };
      }));
    }
  }, []);

  var handleAddBoxOnboarding = function handleAddBoxOnboarding() {
    var newBoxOnboarding = {
      showAdd: false,
      value: {}
    };
    setBoxOnboardingList([].concat((0, _toConsumableArray2.default)(boxOnboardingList), [newBoxOnboarding]));
  };

  var handleDeleteBoxOnboarding = function handleDeleteBoxOnboarding(index) {
    if (index !== 0) {
      var updatedBoxOnboardingList = (0, _toConsumableArray2.default)(boxOnboardingList);
      updatedBoxOnboardingList.splice(index, 1);
      setBoxOnboardingList(updatedBoxOnboardingList);
    } else {
      setIsDeleteDisabled(true);
    }
  };

  (0, _react.useEffect)(function () {
    onChange && onChange(boxOnboardingList);
  }, [boxOnboardingList]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    fontFamily: _variables.FontFamily.Raleway,
    color: _variables.GlobalColors.original_magenta,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
      fontFamily: _variables.FontFamily.Raleway,
      children: inputGroup.dataGroup
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "container-box",
      children: boxOnboardingList.map(function (boxOnboarding, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "container-buttons",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BoxOnboarding.BoxOnboarding, {
              index: index,
              showAdd: boxOnboarding.showAdd,
              data: boxOnboarding.value,
              dataInputs: dataInputs,
              inputs: inputGroup.inputs,
              onChange: function onChange(e) {
                setBoxOnboardingList(function (prev) {
                  return prev.map(function (box, i) {
                    if (i != index) {
                      return box;
                    }

                    return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, box), {}, {
                      value: e
                    });
                  });
                });
              }
            }, index), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BoxButtons.BoxButtons, {
              index: index,
              showAdd: boxOnboarding.showAdd,
              onAdd: handleAddBoxOnboarding,
              onDelete: function onDelete() {
                return handleDeleteBoxOnboarding(index);
              },
              isDeleteDisabled: isDeleteDisabled
            }, index)]
          })
        });
      })
    })]
  });
};

exports.Box = Box;